




















import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import {VModel} from 'vue-property-decorator';
import {DataLoggerFormModel} from '@/context/data_logger/model/form/DataLoggerFormModel';
import {required} from '@/common/validation/validation';
import DataLoggerVersionAutocomplete
  from "@/general/component/form/autocomplete/DataLoggerVersionAutocomplete.vue";

@Component({
  components: {
    DataLoggerVersionAutocomplete,
    DataLoggerAutocomplete,
    FacilityAutocomplete,
    TextInput
  }
})
export default class DataLoggerFormTemplate extends Vue {
  @VModel({type: Object}) model!: DataLoggerFormModel;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      facility: [required],
      identifier: [required]
    };
  }
}
